import { render, staticRenderFns } from "./ProbnaPrijavaPitanja.vue?vue&type=template&id=6d325e2c&scoped=true&"
import script from "./ProbnaPrijavaPitanja.vue?vue&type=script&lang=js&"
export * from "./ProbnaPrijavaPitanja.vue?vue&type=script&lang=js&"
import style0 from "./ProbnaPrijavaPitanja.vue?vue&type=style&index=0&id=6d325e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d325e2c",
  null
  
)

export default component.exports